import { IHttpRequestConfig, post, put } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { consultantInvitationType, IConsultantInvitation, IConsultantInvitationDto } from "./types";

const API = {
  post: "/api/consultant-invitations",
  resend: "/api/consultant-invitations/{invitationId}/resend",
  sendToNotInvited: "/api/consultant-invitations/invite-not-invited",
};

export interface IFetchConsultantInvitationsListParams {}

export interface IPostConsultantInvitationParams {
  companyId: number;
}

export const postConsultantInvitation = (
  params: IPostConsultantInvitationParams,
  data: IConsultantInvitationDto,
  options?: IHttpRequestConfig,
) => {
  const { companyId } = params;
  return post<IConsultantInvitation>(API.post, data, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(consultantInvitationType);
};

export interface IResendConsultantInvitationParams {
  invitationId: number;
  companyId: number;
}

export const resendConsultantInvitation = (params: IResendConsultantInvitationParams, options?: IHttpRequestConfig) => {
  const url = compose(API.resend, params);
  const { companyId } = params;
  return put<IConsultantInvitation>(url, {}, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(consultantInvitationType);
};

export interface ISendConsultantInvitationToNotInvitedParams {
  companyId: number;
}

export const sendConsultantInvitationToNotInvited = (
  params: ISendConsultantInvitationToNotInvitedParams,
  data: Pick<IConsultantProfile, "id" | "signature">,
  options?: IHttpRequestConfig,
) => {
  const { companyId } = params;
  return post<IConsultantInvitation>(
    API.sendToNotInvited,
    { consultantProfile: data },
    applyHeaders({ companyId }, options),
  )
    .then(extractDataFromResponse)
    .then(consultantInvitationType);
};
